module.exports = __webpack_public_path__ + "img/billie_eilish.27e624e8.jpg";